import React from 'react';
import { fetchProductTypeList as fetchProductTypeListService } from '../../services/productTypeService';
import { ProductType } from '../../state/productType';
import AsyncAutoComplete from './AsyncAutoComplete';

interface ProductTypeComboBoxProps {
  handleChange: (result: ProductType) => void;
  selectedValue: ProductType;
  isDisabled?: boolean;
  error?: boolean;
  helperText?: string;
}

const ProductTypeComboBox: React.FC<ProductTypeComboBoxProps> = props => {
  const { handleChange, selectedValue, isDisabled = false, error, helperText } = props;

  const productTypePromiseOptions = async (inputValue: string) => {
    const { data: rows } = await fetchProductTypeListService({
      filters: { 'Name.startsWith': inputValue },
      paging: { pageNumber: 0, pageSize: 10 },
    });

    return rows;
  };

  return (
    <AsyncAutoComplete
      name="ProductType"
      label={'Product Type (HL/NL/PL/TL/WL)'}
      value={selectedValue}
      getOptionValue={(option: ProductType) => {
        return option.id!.toString();
      }}
      getOptionLabel={(option: ProductType) => {
        return option.name;
      }}
      promiseOptions={productTypePromiseOptions}
      placeholder={'Type ProductType Name'}
      handleChange={handleChange}
      isDisabled={isDisabled}
      error={error}
      helperText={helperText}
    />
  );
};

export default ProductTypeComboBox;
